const transformExponentialNumber = (flowDataValue, flowDataName) => {
  if (!["BalanceBefore", "BalanceAfter"].includes(flowDataName)) {
    return flowDataValue;
  }

  let decimal = flowDataValue.toString().toLowerCase();

  if (decimal.toLowerCase().includes('e-')) {
    const exponentialSplit = decimal.split('e-');

    let prefix = parseFloat(exponentialSplit[0]) > 0 ? '0.' : '-0.';

    for (let i = 0; i < +exponentialSplit[1] - 1; i++) {
      prefix += '0';
    }

    decimal = prefix + exponentialSplit[0].replace('.', '').replace('-', '');
  }

  return decimal;
};

export default transformExponentialNumber;
